import { Dialog } from 'primereact/dialog';
import classes from './summary.module.scss';
import { Button } from 'primereact/button';
import { observer } from 'mobx-react';

const SummaryModal = ({
  visibility,
  toggleVisibility,
  planningMonths,
  getValues,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  planningMonths: { label: string; dateString: string }[];
  getValues: (
    cot: string,
    planningMonth: string,
    category: string,
    need: string
  ) => string | undefined;
}) => {
  const cots: { cot: string; value: string }[] = [
    { value: 'cmop', cot: 'CMOP' },
    { value: 'va facility', cot: 'VA Facility' },
    { value: 'tmop', cot: 'TMOP' },
    { value: 'mtf', cot: 'MTF' },
  ];

  return (
    <Dialog
      visible={visibility}
      style={{ width: '75vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
      headerStyle={{ display: 'none' }}
      contentStyle={{ padding: '0', margin: '0', borderRadius: '10px' }}
      closable={false}
    >
      <div className={classes.headingContainer}>
        <h3>Direct</h3>
      </div>
      {/* Direct table start */}
      <div className={classes.tableContainer}>
        <table>
          <thead>
            <td>COT</td>

            {planningMonths.map(month => {
              return <td>{month.label}</td>;
            })}
          </thead>
          <tbody>
            {cots.map(item => {
              return (
                <tr>
                  <td>{item.cot}</td>
                  {planningMonths.map(month => {
                    return <td>{getValues(item.cot, month.dateString, 'direct', 'msplan')}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Direct table end */}

      <div className={classes.headingContainer} style={{ marginTop: '1rem' }}>
        <h3>Indirect</h3>
      </div>

      {/* indirect table start */}
      <div className={classes.tableContainer}>
        <table>
          <thead>
            <td>COT</td>

            {planningMonths.map(month => {
              return <td>{month.label}</td>;
            })}
          </thead>
          <tbody>
            {cots.map(item => {
              return (
                <tr>
                  <td>{item.cot}</td>
                  {planningMonths.map(month => {
                    return <td>{getValues(item.cot, month.dateString, 'indirect', 'msplan')}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* indirect table end */}

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={toggleVisibility} className={classes.cancelButton}>
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};

export default observer(SummaryModal);
